module.exports = __webpack_public_path__ + "static/rc-2-295466dc179398acf37a2e203d8ba3a2.jpg";